import Alert from "@pathwright/ui/src/components/alert/Alert"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import { useUnlockPathItemMutation } from "@pathwright/web/src/modules/api/generated"
import { ConnectForm, TextInput, validate } from "lib/core/components/forms"
import "./StepPasswordLock.css"

let fieldsData = {
  password: {
    label: "Password",
    type: "password",
    placeholder: "Enter password to unlock this step...",
    validations: [validate.minLength(1)],
    hideStatus: true,
    inline: true
  }
}

const StepPasswordLock = function ({
  fieldsData,
  isValid,
  step,
  isSubmitting
}) {
  const [unlockPathItem, { error }] = useUnlockPathItemMutation({
    variables: {
      id: step.id,
      path_id: step.path_id,
      step_lock_password: fieldsData.password.value
    }
  })

  return (
    <>
      {error && <Alert error={error} />}
      <BlankSlate icon="lock" body="This step is password protected.">
        <form
          className="StepPasswordLock__form"
          onSubmit={async (e) => {
            e.preventDefault()
            await unlockPathItem()
            App.getStore("step").action.loadStep()
          }}
        >
          <TextInput {...Object.assign({}, fieldsData.password)} />
          <SubmitButton
            disabled={!isValid}
            isSubmitting={isSubmitting}
            styleType="primary"
            type="submit"
            size="large"
            rounded={false}
          >
            Unlock
          </SubmitButton>
        </form>
      </BlankSlate>
    </>
  )
}

StepPasswordLock.displayName = "StepPasswordLock"

const StepPasswordLockForm = ConnectForm(StepPasswordLock, fieldsData)

export default StepPasswordLockForm
